export default {"src":"/_next/static/media/pup-info.07392303.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};